var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General-System",
    transform: "translate(171.457 192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GeneralSystems_CloseRemove_Primary_24",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CloseRemove",
    className: "st0",
    d: "M-135.3-193l-17.2,17.2l-17.2-17.2l-2.8,2.8l17.2,17.2l-17.2,17.2l2.8,2.8l17.2-17.2 l17.2,17.2l2.8-2.8l-17.2-17.2l17.2-17.2L-135.3-193z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.d4d65abba92c09f5de480ead622271dc.svg";
export { ForwardRef as ReactComponent };